import axios from 'axios';

export default{
   

    get(url,params,responseType){
        responseType = responseType ? responseType : 'json'
        return axios ({
            // url: 'http://jhf-admin.test/api/list/features',
            url: this.constructParams(url,params),
            method: 'get',
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },        
            responseType: responseType

        })
    },
    post (url,params) {
       return  axios ({
            url: url,
            method: 'post',
            data: params,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            }            
        
            // ... and other options 
        })
    },
    update(url,params){
        axios ({
            url: url,
            method: 'post',
            data: params,
            headers: {'X-Requested-With': 'XMLHttpRequest'},
        
            // ... and other options 
        })
    },
    delete(url){
        axios ({
            url: url,
            method: 'delete',
            data: {
            },
            headers: {'X-Requested-With': 'XMLHttpRequest'},
        
            // ... and other options 
        })
    },
    constructParams(url,parameters){
        var qs = "";
        for(var key in parameters) {
          var value = parameters[key];
          qs += encodeURIComponent(key) + "=" + encodeURIComponent(value) + "&";
        }
        if (qs.length > 0){
          qs = qs.substring(0, qs.length-1); //chop off last "&"
          url = url + "?" + qs;
        }
        return url;
    }

}